import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function SwipeIn(props) {
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="SwipeInIcon">
                <path d="M42.25,1h-23a1.44,1.44,0,0,0-1.44,1.44V16.81h2.88V3.88H40.81V44.13H20.69V31.19H17.81V45.56A1.44,1.44,0,0,0,19.25,47h23a1.44,1.44,0,0,0,1.44-1.44V2.44A1.44,1.44,0,0,0,42.25,1Z" />
                <path d="M22,31.61l2,2L32.64,25a1.45,1.45,0,0,0,0-2L24,14.36l-2,2,6.17,6.17H4.31v2.88H28.15Z" />
            </g>
        </SvgIcon>
    );
}

export default SwipeIn;